import gql from 'graphql-tag';

import { StarCountBreakdownFragment } from 'bundles/video-logged-out-page/components/course-content/CourseReviews';

export const FetchProductOverviewQueryVlp = gql`
  query FetchProductOverviewQueryVlp($courseSlug: String!) {
    XdpV1Resource {
      slug(productType: "COURSE", slug: $courseSlug) {
        elements {
          id
          fetchProductOverview {
            elements {
              ...StarCountBreakdownFragment
            }
          }
        }
      }
    }
  }
  ${StarCountBreakdownFragment}
`;
